import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Box, Paper, Tab, Tabs } from "@mui/material";
import DashboardLayout from "../../../layouts/DashboardLayout";
import PageHeader from "../../../components/layout/PageHeader";
import EgresoChequesTab from "../components/EgresoChequesTab";
import BusquedaTab from "../components/BusquedaTab";
import PresupuestoTab from "../components/PresupuestoTab";
import ExtractoTab from "../components/ExtractoTab";
import SolicitudesTab from "../components/SolicitudesTab";
import ReportesCajaGeneralTab from "../components/ReportesCajaGeneralTab";

const ReportesBalanceTab = () => <ReportesCajaGeneralTab modo="balance" />;

// Pestañas del módulo Egresos (migradas desde el sistema viejo).
// Clave corta de cada pestaña para abrirla por enlace (p. ej. /egresos?tab=solicitudes desde las notificaciones).
const CLAVES_TAB = { cheques: 0, "caja-general": 1, balance: 2, busqueda: 3, solicitudes: 4, extracto: 5, presupuesto: 6 };

const TABS = [
  { label: "Egreso de Cheques", component: EgresoChequesTab },
  { label: "Reportes Caja General", component: ReportesCajaGeneralTab },
  { label: "Reportes de Balance", component: ReportesBalanceTab },
  { label: "Búsqueda", component: BusquedaTab },
  { label: "Solicitudes", component: SolicitudesTab },
  { label: "Extracto Histórico", component: ExtractoTab },
  { label: "Presupuesto", component: PresupuestoTab },
];

export default function EgresosPage() {
  const [params] = useSearchParams();
  const tabEnlace = CLAVES_TAB[params.get("tab")];
  const [tab, setTab] = useState(tabEnlace ?? 0);
  useEffect(() => { if (tabEnlace !== undefined) setTab(tabEnlace); }, [tabEnlace]);
  const Actual = TABS[tab].component;

  return (
    <DashboardLayout>
      <PageHeader title="Egresos" showBack={false} />
      <Box sx={{ p: { xs: 0.5, md: 1 } }}>
        <Paper variant="outlined" sx={{ mb: 1 }}>
          <Tabs value={tab} onChange={(_, v) => setTab(v)} variant="scrollable" scrollButtons="auto"
            sx={{ minHeight: 34, "& .MuiTab-root": { minHeight: 34, py: 0.5, fontSize: 12.5, textTransform: "none", fontWeight: 700 } }}>
            {TABS.map((t) => <Tab key={t.label} label={t.label} />)}
          </Tabs>
        </Paper>
        <Actual onIrABusqueda={() => setTab(TABS.findIndex((t) => t.label === "Búsqueda"))} />
      </Box>
    </DashboardLayout>
  );
}
